<div #modalBackground class="modal" *ngIf="show"
     (click)="(closable && $event.srcElement == modalBackground) ? close($event, modalBackground) : return;">
  <mat-card class="modal-box limit-preview">
    <mat-card-title class="modal-title">
      <ng-content select=".modal-title-content"></ng-content>
      <span *ngIf="closable" class="close" (click)="close()">
        <i class="material-icons close-ic">close</i>
      </span>
    </mat-card-title>
    <mat-card-content class="modal-content">
      <ng-content select=".modal-body-content"></ng-content>
    </mat-card-content>
    <mat-card-actions class="modal-footer" align="end">
      <ng-content select=".modal-footer-content"></ng-content>
    </mat-card-actions>
  </mat-card>
</div>

